export default __webpack_public_path__ + "static/media/logo-header.d94c4e05.png";